(function($) {
    var CC_TYPE_MASTERCARD = 1;
    var CC_TYPE_VISA = 2;
    var CC_TYPE_DISCOVER = 3;
    var CC_TYPE_AMERICANEXPRESS = 4;

    $.widget("ca.caCCNumber", {
        icons: {},
        securityCode: $(),

        _create: function() {
            var self = this;

            if (this.options.cardTypes && this.options.cardTypes.length > 0) {
                var types = $('<div></div>').addClass('ca-cc-types');
                $.each(this.options.cardTypes, function() {
                    var enabled = this.status == 1;
                    var icon = $();
                    var type = +this.id;

                    if (enabled) {
                        icon = $('<div></div>')
                            .addClass('ca-cc-sprite')
                            .addClass(self.getClassForType(type));
                        types.append(icon);
                    }

                    self.icons[this.id] = {
                        type: type,
                        name: this.name,
                        enabled: enabled,
                        icon: icon
                    };
                });

                this.element.after(types);
            }

            if (this.options.securityCode) {
                this.securityCode = $('#' + this.options.securityCode);
            }

            this.hideCardIcons();

            this.element.on('keyup', function() {
                self.hideCardIcons();
                var type = self.checkCardType(this.value);
                if (type !== undefined) {
                    self.icons[type].icon.fadeTo('fast', 1);
                    self.securityCode.attr('placeholder', self.getSecurityCodePlaceholder(type));
                }
            });

            this.element.on('blur', function() {
                $(this).parent().find('.help-block.animation-slideDown').remove();
                $(this).parent().removeClass('has-error');

                var type = self.checkCardType(this.value);
                if (type == undefined) {
                    self.element.trigger("error", {
                        card_number: ["Please enter a valid credit card number"]
                    });
                } else if (!self.icons[type].enabled) {
                    self.element.trigger("error", {
                        card_number: [self.icons[type].name + " is not accepted"]
                    });
                }
            });
        },

        getClassForType: function(type) {
            switch (type) {
                case CC_TYPE_MASTERCARD:
                    return 'cc-sprite-master-card';

                case CC_TYPE_VISA:
                    return 'cc-sprite-visa';

                case CC_TYPE_DISCOVER:
                    return 'cc-sprite-discover';

                case CC_TYPE_AMERICANEXPRESS:
                    return 'cc-sprite-american-express';
            }
        },

        hideCardIcons: function() {
            $.each(this.icons, function () {
                this.icon.stop().fadeTo(0, 0.6);
            });

            this.securityCode.attr('placeholder', '');
        },

        checkCardType: function(cardNumber) {
            function validateCardFirstNumbers(startNumber, endNumber) {
                if (endNumber !== undefined) {
                    for (var i = startNumber; i <= endNumber; i++) {
                        if (validateCardFirstNumbers(i)) {
                            return true;
                        }
                    }

                    return false;
                }

                startNumber = startNumber + "";
                return cardNumber.substring(0, startNumber.length) === startNumber;
            }

            if (cardNumber.length == 16 && validateCardFirstNumbers(4)) {
                return CC_TYPE_VISA;
            }

            if (cardNumber.length == 15
                && (validateCardFirstNumbers(34) || validateCardFirstNumbers(37))
            ) {
                return CC_TYPE_AMERICANEXPRESS;
            }

            if (cardNumber.length == 16 && validateCardFirstNumbers(51, 55)) {
                return CC_TYPE_MASTERCARD;
            }

            if (cardNumber.length == 16
                && (validateCardFirstNumbers(6011) 
                    || validateCardFirstNumbers(622126, 622925) 
                    || validateCardFirstNumbers(644, 649) 
                    || validateCardFirstNumbers(65)
                )
            ) {
                return CC_TYPE_DISCOVER;
            }

            return undefined;
        },

        getSecurityCodePlaceholder: function(type) {
            if (type == CC_TYPE_AMERICANEXPRESS) {
                return '4 digit code on the front of the card';
            }

            return '3 digit code next to the signature box';
        }
    });
})(jQuery);
